// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"loadingComponent__gradient-bg5__UN94Y","loadingContainer":"loadingComponent__loadingContainer__HfEyc"};